import { Bones } from '@simplywallst/ui-core';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { useIsMobileScreen } from '@/hooks/useMedia';

export const PortfolioOverviewLoadingState = () => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return (
    <div
      className="grid grid-rows-[auto_auto] gap-x2 md:grid-cols-[auto_32%] md:grid-rows-[auto]"
      data-cy-id="portfolio-overview-loading-state"
    >
      <div className="grid bg-legacy-noir lg:gap-x0_5 lg:rounded-x1">
        <div>
          <div className="grid p-x2 pr-x1_5 lg:pb-x2 lg:pl-x3">
            <div className="grid gap-x2">
              <Bones minHeight="24px" maxWidth="150px" />
              <div className="overflow-auto">
                <div className="grid grid-cols-[repeat(3,max-content)] gap-x4">
                  <div className="grid grid-cols-[4px_max-content] gap-x1_5">
                    <div className="grid w-x0_5 rounded-x1_25 bg-legacy-darkergray" />
                    <div className="grid gap-x0_25">
                      <Bones minHeight="30px" minWidth="100px" />
                      <Bones minWidth="100px" />
                    </div>
                  </div>
                  <div className="grid grid-cols-[4px_max-content] gap-x1_5">
                    <div className="grid w-x0_5 rounded-x1_25 bg-legacy-darkergray" />
                    <div className="grid gap-x0_25">
                      <Bones minHeight="30px" minWidth="100px" />
                      <Bones minWidth="100px" />
                    </div>
                  </div>
                  <div className="grid grid-cols-[4px_max-content] gap-x1_5">
                    <div className="grid w-x0_5 rounded-x1_25 bg-legacy-darkergray" />
                    <div className="grid gap-x0_25">
                      <Bones minHeight="30px" minWidth="100px" />
                      <Bones minWidth="100px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative p-x2 lg:px-x3 lg:py-x2">
          {!isMobileScreen ? (
            <div className="absolute right-x3 rounded-x1 bg-legacy-noir p-x0_5">
              <div className="grid grid-cols-[1fr]">
                <Bones minWidth="200px" minHeight="30px" />
              </div>
            </div>
          ) : null}
          <div className="grid grid-cols-[max-content_max-content] items-center gap-x4 pb-x2">
            <div className="grid grid-rows-[min-content_23px] items-center lg:grid-rows-[min-content_26px]">
              <p className="m-x0 text-tiny text-softer">Holdings</p>
              <Bones minHeight="12px" maxWidth="50px" />
            </div>
            <div className="grid grid-rows-[min-content_23px] items-center lg:grid-rows-[min-content_26px]">
              <p className="m-x0 text-tiny text-softer">Market</p>
              <Bones minHeight="12px" maxWidth="50px" />
            </div>
          </div>
          <div className="grid grid-cols-[1fr]">
            <Bones minHeight="200px" />
          </div>
        </div>
      </div>
      <div className="grid gap-x2 rounded-x1 bg-legacy-noir p-x2">
        <Bones maxHeight="24px" maxWidth="100px" />
        <div className="grid place-content-center">
          <div className="w-[220px]" data-cy-id="snowflake-overview">
            <Bones minHeight="220px" maxWidth="220px" borderRadius="x20" />
          </div>
        </div>
        <div className="grid gap-x1">
          <Bones maxHeight="16px" maxWidth="75%" />
          <Bones maxHeight="16px" maxWidth="25%" />
        </div>
        <div className="grid grid-cols-[max-content_auto] items-center justify-start gap-x2">
          <Bones minHeight="24px" maxWidth="150px" />
        </div>
      </div>
    </div>
  );
};
